import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, ref, computed, onMounted } from 'vue';
import { BuyerSource } from '@/Sources';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewBuyerDropdownField',
  props: {
    value: { type: String, required: true },
    errorText: { type: String, required: false, default: '' },
    label: { type: String, required: false, default: 'Buyer' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({ (event: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, errorText: string, label: string, disabled: boolean, autoAssign: boolean, placeholder?: string };




const source = ref(new BuyerSource(true));
const searchText = ref('');
const sourceOption = ref<HTMLSamcOptionSourceElement | null>(null);

const val = computed({
  get: () => props.value,
  set: (value: string) => {
    emits('input', value);
  }
});

/**
 * Lifecycle hook is called once this dropdown is created
 **/
onMounted(async () => {
  if (sourceOption.value !== null) {
    sourceOption.value.source = source.value as any;
  }
});

/**
 * Initial load method that is called once the source is updated and will auto assign if needed
 */
const onInitialLoad = () => {
  if (props.autoAssign && !props.value && source.value.items.length > 0) {
    const first = source.value.items[0];
    val.value = first.id;
  }
}

return { __sfc: true,emits, props, source, searchText, sourceOption, val, onInitialLoad }
}

})